import { Component } from '@angular/core';

@Component({
  selector: 'app-projects-cta',
  imports: [],
  templateUrl: './projects-cta.component.html',
  styleUrl: './projects-cta.component.css',
})
export class ProjectsCtaComponent {

}
